// extracted by mini-css-extract-plugin
export var dateLabel = "_38-0";
export var dateLabelError = "_38-1";
export var fullWidth = "_38-2";
export var smaller = "_38-3";